/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:40:25
 */
export default {
  lang: "英语",
  landing: {
    name1: "Carlcare bani",
    name2: "Bakka qabachuu",
    name3: "Carlcare dhan, yeroo kamiyyuu ajaja kee mirkaneessuu dandeessaa.",
    name4: "",
    name5: "Gara mirgaatti mucuceessi",
    name6: "Mirkaneessi xumurameera",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for Infinix/Tecno/itel designated models.",
    name11: "Starting from ₱500, you can get your battery replaced with no labor fee.",
    name12: 'The battery price may vary depending on the model. Please refer to the price list below for details.', // 小字标注
    name13: "Why Choose Carlcare Flat Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    // name16: "Lower and Transparent Pricing",
    // name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy a 3-month warranty for your new battery.",
    name20: "Lower and Affordable Price",
    name21: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for battery replacements only and is limited to specific models.",
    name27: "3. If you join the flat price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the final right to interpret this promotion.",
    name31: "Carlcare Statements:",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "Starting from ₱500",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
    name40: "Original Battery",
    name41: "Affordable Price",
    name42: "Free Labor Fee",
  },
  order: {
    name1: "Moodeela meeshaa filadhu",
    name2: "Ibsaa dabalataa dogogoraa:",
    name3: "Kuusaa tajaajilaa filachuuf tuqi",
    name4: "Kuusaa tajaajilaa",
    name5: "Yeroo qabamee:",
    name6: "Maaloo rakkoo meeshaa bal/'inaan ibsi!",
    name7: "Yeroo gaahumsaa filachuuf tuqi",
    name8: "Maaloo akka si qunnamnuuf qunnamtii kee sirrii sirnaan galchi!",
    name9: "Yeroon affeerraa argamu kanneen armaan gadiiti",
    name10: "Maalo lakkofsaa bilbilaa kee galchii",
    name11: "Gatii",
    name12: "Odeeffanno dhunfaa:",
    name13: "Maale maqaa kee galchi",
    name14: "Ergi",
    name15: "Haqi",
    name16: "TOLE",
  },
  shops: {
    name1: "Biraandii filattee irratti hunda\'uun, kuusaan armaan gadii siif dhihaata!",
    name2: "Kuusaa jimlaa dabalataan dhufaa jira! Nuu waliin tura!",
  },
  price: {
    name1: "Birandii",
    name2: "Moodeela",
    name3: "WANTA",
    name4: "Gatii",
    name5: "Yaadachiisa hiriyuummaa:",
    name6: "Gatiin kun ka/'uumsaaf qofaadha, gatiin sirriin haala meeshaa irratti hunda/'uun hojjatama.",
    name7: "Yoo mallattoon adda ta/'ee hin jirre, gatiin isaa sharafa biyya keessaan hojjatama.",
    name8: "Dhiifama! Naannoo ammaa kana odeeffannoon gatii argamu hin jiru.",
    name11:"Gatii Humnaa",
    name12:"Gatii Waliigalaa",
    name13: "5. Yoo baasii humna namaa  \"/\" ta’e, baasii humna namaa mana daldalaa waliin mari\'achuu qaba jechuudha.",
    item_main_board: "Boordii ijoo",
    item_screen_frame: "Argii (Fireemii)",
    item_screen_screen_frame: "Argii Lammaffaa (Fireemii)",
    item_touch_screen: "Argii Tuqi",
    item_camera: "Kaameeraa",
    item_fixed_focus_camera: "Kaameeraa Xiyyeeffannoo Dhaabbataa",
    item_auto_focus_camera: "Kaameeraa Xiyyeeffannoo Ofnaa",
    item_screen: "Argii",
    item_secondary_screen: "Argii Lammaffaa",
    item_fingerprint_module: "Moojula Ashaaraa Qubaan",
    item_speaker: "Sagalee guddistuu",
    item_receiver: "Fudhataa",
    item_small_board: "Boordii Xiqqaa",
    item_battery_cover: "Haguuggii Baatirii",
    item_battery: "Baatirii",
    item_charger: "Chaarjarii",
    item_usb_cable: "Keebilii USB",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "Daataan jin jiru",
    name2: "Dhiheessaa tajaajilaa:",
    name3: "Birandii tajajjilaa:",
    name4: "Bilbila",
    name5: "Baayyina ajajaa:",
    name6: "Sadarkaa tajaajila",
    name7: "Naannoo tajaajilaa:",
    name8: "Ilaalcha tajaajilaa:",
    name9: "Dhaamatii tajaajilaa:",
    name10: "Qulqullina tajaajilaa:",
    name11: "Madaallii maamila",
    name12:"gara",
    name13:"Cufameera",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Carlcare bani",
    name1: "Maaloo odeeffannoo tursiisaa suura argii kaasuun kuusuun tajaajila dursummaa argadhu.",
    name2: "Milka'inaan galchamera",
    name3: "1. Daataa qulleessi",
    name4: "Maaloo bilbila kee irraa daataa dhuunfaa barbaachiisaa ta/'ee dilbeessi",
    name5: "2. Jecha darbiinsaa akka hin hojjannee taasiisii",
    name6: "Gara kuusaa tajaajilaa osoo hin deemin, maaloo:",
    name7: "Kuusaa tajaajilaa",
    name8: "Yeroo qabamee:",
    name9: "Ibsaa dabalataa dogogoraa:",
    name10: "Moodeela meeshaa:",
    name11: "Lakkoofsa ajajaa:",
    name12: "Odeeffannoo ajajaa",
  },
  title: {
   
    name1: "Biyyoota armaan gadii hojjatu:",
    name2: "Moodeela filadhu",
    name3: "Bakkaa qabu",
    name4: "Ibsa dabalata kuusaa tajaajila",
    name5: "Kuusaa tajaajila filadhu",
  },
  error: {
    
    name1: "Daataa kan hin qabne. Maaloo odeeffannoo suphinsaa kee mirkaneessi",
    name2: "Gargaarsaa dabalataa ni barbadaa? Maaloo nun quunami.",
    name3: "Dhiifama, naannoo amma kana giddugalli Carlcare hin jiru.",
    name4: "Maaloo jalqaba giddugala tajaajila filadhu",
    name5: "Hin milkofnee",
    name6: "Maaloo jalqaba moodeela meeshaa filadhu",
    name7: "Ibsaa dabalataa",
    name8: "Maaloo feedhi kee bal/'inaan ibsi",
    name9: "",
  },
  add1:{
    "name0": "om-rET",
    "name1": "Ajajni kees mirkanaa\\'eera. Dhufaatii kee hawwiidhaan eegganna.",
    "name2": "Magalaa filadhu",
    "name3": "Maaloo lakkoofsa bilbilaa diijitii %1$s ta\\'e galchi.",
    "name4": "Sa\\'aatii Dhuma Torbee",
    "name5": "Wiixata",
    "name6": "Kibxataa",
    "name7": "Roobii",
    "name8": "Kamisaa",
    "name9": "Jimataa",
    "name10": "Sanbata",
    "name11": "Dilbata",
    "name12": "Biyya galchuun barbaadi"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "Kan biraa",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"Kallattiitti qajeelchuuf tuqi",
    name3:"Ajaja kana madaluuf app Carlcare bani",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"Tajaajila Filadhu",
    name7:"Qulqulina Bilisaa",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "Odeeffannoo sirrii hin taanee",
    "cancelReason1": "Yeroodhan qaqqabuu hin dandeenye",
    "cancelReason2": "Ajaja wal fakkataa/Ajaja koo miti",
    "cancelReason3": "Kufaatin hin dabalamu",
    "cancelReason4": "Yaaliidhaf/Gaaffii/Taatee….",
    "cancelReason5": "Gatii olaanaa",
    "cancelReason6": "Hir\\'ina meeshaa",
    "cancelReason7": "Tajajjilli adda bahuu hin jiru",
    "cancelReason8": "Kuusaan fagaachuu",
    "cancelReason9": "Kuusaan cufamuu",
    "cancelReason10": "Ilaalcha tajaajila badaa",
    "cancelReason11": "Biraandii biraa bakka buusuu/deebisanii suphuu",
    "cancelReason12": "Kuusaa argachuu hin dandeenye",
    "cancelReason13": "Kan biraa",
    "cancelOrder": "Ajjaja dhisii",
    "reason_dialog_title": "Maaloo sababa haqiinsaa nutti himaa",
    "Cancel": "Dhisi",
    "OK": "Tole",
    "name1": "Kodii mirkanesituu galchii",
    "name2": "Koodii mirkaneessaa sirrii hin taane",
    "repair_reservation_detail_canceled": "Ajajni haqameera!",
    "purchase_cancel_dialog_content": "Ajaja haquuf mirkanneesitee jirtaa?",
    "yes": "Eyyee",
    "no": "Lakkii"
}
};
